export const BUNDLE_RECIPES_CONFIG_KEY = 'fulfillment-bundle-recipes';

export interface BundleRecipeComponent {
  sku: string;
  quantity: number;
}

export interface BundleRecipesConfig extends Record<string, unknown> {
  recipes: Record<string, BundleRecipeComponent[]>;
}
